import {
  GEOGRAPHY_GET_LIST,
  GEOGRAPHY_GET_LIST_SUCCESS,
  GEOGRAPHY_GET_LIST_ERROR,
  GEOGRAPHY_GET_LIST_WITH_FILTER,
  GEOGRAPHY_GET_LIST_WITH_ORDER,
  GEOGRAPHY_GET_LIST_SEARCH,
  GEOGRAPHY_SELECTED_ITEMS_CHANGE,
  GEOGRAPHY_DELETE_ITEM,
  GEOGRAPHY_DELETE_ITEM_SUCCESS,
  GEOGRAPHY_DELETE_ITEM_ERROR,
} from '../actions';

const INIT_STATE = {
  geographys: [],
  geography: [],
  error: '',
  filter: null,
  searchKeyword: '',
  orderColumn: null,
  loading: false,
  labels: [
    { label: 'EDUCATION', color: 'secondary' },
    { label: 'NEW FRAMEWORK', color: 'primary' },
    { label: 'PERSONAL', color: 'info' },
  ],
  orderColumns: [
    { column: 'id', label: 'Id' },
    { column: 'name', label: 'Name' },
    { column: 'hid', label: 'HST' },
    { column: 'pcc', label: 'PCC' },
    { column: 'note', label: 'Note' },
  ],
  categories: ['Flexbox', 'Sass', 'React'],
  selectedItems: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GEOGRAPHY_GET_LIST:
      return { ...state, loading: false };

    case GEOGRAPHY_GET_LIST_SUCCESS:
      return { ...state, loading: true, geographys: action.payload, geography: action.payload };

    case GEOGRAPHY_GET_LIST_ERROR:
      return { ...state, loading: true, error: action.payload };

    case GEOGRAPHY_GET_LIST_WITH_FILTER:
      if (action.payload.column === '' || action.payload.value === '') {
        return { ...state, loading: true, geography: state.geographys, filter: null };
      } else {
        const filteredItems = state.geographys.filter(
          item => item[action.payload.column] === action.payload.value
        );
        return {
          ...state,
          loading: true,
          geography: filteredItems,
          filter: {
            column: action.payload.column,
            value: action.payload.value,
          },
        };
      }

    case GEOGRAPHY_GET_LIST_WITH_ORDER:
      if (action.payload === '') {
        return { ...state, loading: true, geography: state.geography, orderColumn: null };
      } else {
        const sortedItems = state.geographys.sort((a, b) => {
          if (a[action.payload] < b[action.payload]) return -1;
          else if (a[action.payload] > b[action.payload]) return 1;
          return 0;
        });
        return {
          ...state,
          loading: true,
          geography: sortedItems,
          orderColumn: state.orderColumns.find(x => x.column === action.payload),
        };
      }

    case GEOGRAPHY_GET_LIST_SEARCH:
      if (action.payload === '') {
        return { ...state, geography: state.geographys };
      } else {
        const keyword = action.payload;
        const searchItems = state.geographys.filter(
          item =>
            String(item.id).startsWith(keyword) ||
            String(item.name.toLowerCase()).startsWith(keyword) ||
            String(item.note.toLowerCase()).startsWith(keyword)
        );
        return { ...state, loading: true, geography: searchItems, searchKeyword: action.payload };
      }

    case GEOGRAPHY_SELECTED_ITEMS_CHANGE:
      return { ...state, loading: true, selectADD_OR_UPDATEems: action.payload };
    default:
      return { ...state };

    case GEOGRAPHY_DELETE_ITEM:
      return { ...state, loading: false };

    case GEOGRAPHY_DELETE_ITEM_SUCCESS:
      return { ...state, loading: true, geographys: action.payload, geography: action.payload };

    case GEOGRAPHY_DELETE_ITEM_ERROR:
      return { ...state, loading: true, error: action.payload };
  }
};
